<template>
	<div>
		<v-row>
			<tile-container :size="communityTile.size">
				<component :is="communityTile.component" :community="community" />
			</tile-container>

			<tile-container :size="systemStatusTile.size">
				<component :is="systemStatusTile.component" />
			</tile-container>

			<tile-container
				v-for="user in users"
				:key="user.id"
				:size="userPreviewTile.size"
			>
				<component :is="userPreviewTile.component" :user="user" />
			</tile-container>

			<tile-container :size="systemDevicesTile.size">
				<component :is="systemDevicesTile.component" />
			</tile-container>

			<tile-container :size="systemScenesTile.size">
				<component :is="systemScenesTile.component" />
			</tile-container>
		</v-row>
	</div>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";

import api from "@/api/cloud";
import { createUser } from "@/store/model/user";

import TileContainer from "./shared/TileContainer";

import {
	communityTile,
	userPreviewTile,
	systemStatusTile,
	systemDevicesTile,
	systemScenesTile,
} from "./tiles";

export default {
	components: { TileContainer },

	data: () => ({
		communityTile,
		userPreviewTile,
		systemStatusTile,
		systemDevicesTile,
		systemScenesTile,

		users: [],
	}),

	beforeRouteEnter(to, from, next) {
		return next(vm => {
			// Start connecting to controller's remote k4 model
			vm.loadRemoteController(vm.system.id);
		});
	},

	beforeRouteLeave(to, from, next) {
		// Make sure we disconnect from controller before leaving
		this.$store.commit("controller/resetState");

		return next();
	},

	computed: {
		...mapGetters({
			community: "session/community",
			system: "session/system",
		}),
	},

	beforeMount() {
		this.loadSystemUsers();
	},

	methods: {
		...mapActions({ loadRemoteController: "controller/loadRemote" }),

		async loadSystemUsers() {
			const systemId = this.system.id || this.system._id;
			const users = await api.getSystemUsers(systemId);
			this.users = _.map(users, (user)=>createUser(user));
		},
	},
};
</script>
